import { call, put, takeEvery ,takeLatest} from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as nkActions from './actions'
function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function listNCCRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_LIST_NCC_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoListNccRequestFlow (action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listNCCRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(nkActions.nhapkhoListNhaCCSuccess(results.data))

  } catch (error) {
    yield put(nkActions.nhapkhoListNhaCCError(error))
  }
}
function listKhoRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_LIST_KHO_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoListKhoRequestFlow (action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listKhoRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(nkActions.nhapkhoListKhoSuccess(results.data))

  } catch (error) {
    yield put(nkActions.nhapkhoListKhoError(error))
  }
}

function* nhapkhoListProductFlow (action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    // eslint-disable-next-line no-use-before-define
    const results = yield call(nhapkhoListProductApi, formData)

    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoListProductSuccess(results.data))
    if (typeof callback == 'function')
    {
      yield callback(results);
    }  
  } catch (error) {
    yield put( nkActions.nhapkhoListProductError(error))
  }
}


function nhapkhoListProductApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_LIST_PRODUCT_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoSaveRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    // eslint-disable-next-line no-use-before-define
    const { data } = yield call(nhapkhoSaveApi, formData)

    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoSaveSuccess(data));

    if (typeof callback === 'function') {
      yield call(callback, data);
    }  
  } catch (error) {
    yield put( nkActions.nhapkhoSaveError(error))
  }
}
function nhapkhoSaveApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_SAVE_API, 
    formData
  )

  return handleRequest(request);
}
function nhapkhoUpdateApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* nhapkhoUpdateRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nhapkhoUpdateApi, formData)
    if (results.code !== 200) {
      yield put(nkActions.nhapkhoUpdateError(results.message))
    }
    else{
    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoUpdateSuccess(results.data))
  }
  } catch (error) {
    yield put( nkActions.nhapkhoUpdateError(error))
  }
}
function nhapkhoDetailApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}
function* loadKhachHang({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      Constants.NHAPKHO_LOAD_KHACHHANG_API,
      payload
    )
    const { data } = yield call(handleRequest, request)
    let items = []
    if (data) {
      items = JSON.parse(data)
    }
    yield call(onSuccess, items)
  } catch (error) {
    console.log(error)
  }
}
function*  nhapkhoDetailFlow (action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call( nhapkhoDetailApi, formData)

    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoDetailSuccess(results.data))

  } catch (error) {
    yield put( nkActions.nhapkhoDetailError(error))
  }
}
function listDvtRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_PRODUCTS_LIST_DVT_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoProductsListDvtRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listDvtRequestApi, formData)

    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoProductsListDvtSuccess(results.data))

  } catch (error) {
    yield put( nkActions.nhapkhoProductsListDvtError(error))
  }
}
function nhapkhoDuyetApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_DUYET_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoDuyetRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(nhapkhoDuyetApi, formData)
    if (results.code !== 200) {
      yield put(nkActions.nhapkhoDuyetError(results.message))
    }else{
    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoDuyetSuccess(results.data));
  }  
    if (typeof callback == 'function')
    {
      yield put( nkActions.callback(results.data));
    }  

  } catch (error) {
    yield put( nkActions.nhapkhoDuyetError(error))
  }
}
function nhapkhoHuyDuyetApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_HUY_DUYET_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoHuyDuyetRequestFlow (action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(nhapkhoHuyDuyetApi, formData)
    if (results.code !== 200) {
      yield put(nkActions.nhapkhoHuyDuyetError(results.message))
    }else{
    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoHuyDuyetSuccess(results.data));
  }
    if (typeof callback == 'function')
    {
      yield put( nkActions.callback(results.data));
    }  

  } catch (error) {
    yield put( nkActions.nhapkhoHuyDuyetError(error))
  }
}
function nhapkhoGenBarCodeApi (formData) {
  const request = axiosApi().post(
    Constants.NHAPKHO_GEN_BARCODE_API, 
    formData
  )

  return handleRequest(request);
}
function* nhapkhoGenBarCodeFlow (action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(nhapkhoGenBarCodeApi, formData)

    // dispatch the action with our widgets!
    yield put( nkActions.nhapkhoGenBarCodeSuccess(results.data))
    if (typeof callback == 'function')
    {
      yield callback(results);
    }  
  } catch (error) {
    yield put( nkActions.nhapkhoGenBarCodeError(error))
  }
}

function* nhapkhoWatcher () {
  yield takeLatest(Constants.NHAPKHO_DETAIL_REQUESTING,  nhapkhoDetailFlow)
  yield takeLatest(Constants.LOAD_KHACH_HANG,  loadKhachHang)
  yield [
    takeEvery(Constants.NHAPKHO_LIST_NCC_REQUESTING, nhapkhoListNccRequestFlow),
    takeEvery(Constants.NHAPKHO_LIST_KHO_REQUESTING, nhapkhoListKhoRequestFlow),
    takeEvery(Constants.NHAPKHO_LIST_PRODUCT_REQUESTING, nhapkhoListProductFlow),
    takeEvery(Constants.NHAPKHO_UPDATE_REQUESTING, nhapkhoUpdateRequestFlow),
    takeEvery(Constants.NHAPKHO_SAVE_REQUESTING, nhapkhoSaveRequestFlow),
    takeEvery(Constants.NHAPKHO_PRODUCTS_LIST_DVT_REQUESTING,nhapkhoProductsListDvtRequestFlow),
    takeEvery(Constants.NHAPKHO_GEN_BARCODE_REQUESTING, nhapkhoGenBarCodeFlow),
    takeEvery(Constants.NHAPKHO_DUYET_REQUESTING, nhapkhoDuyetRequestFlow),
    takeEvery(Constants.NHAPKHO_HUY_DUYET_REQUESTING, nhapkhoHuyDuyetRequestFlow),
  ]
}

export default nhapkhoWatcher



// WEBPACK FOOTER //
// ./src/views/NhapKho/sagas.js